export function connectScrollTop(router) {
  return router.subscribe(() => window.scrollTo(0, 0));
}
